import { type MutableRefObject, useEffect, useRef } from 'react';

export function usePrevious<T>(value: T): MutableRefObject<T | null>['current'] {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
